<div class="add-items-container">
    <div class="top-row">
        <p-breadcrumb [model]="breadcrumbItems" (onItemClick)="onBreadcrumbClick($event)"></p-breadcrumb>
        <div class="top-actions">
            <p-button label="Cancel" [outlined]="true" styleClass="cancel-btn" (onClick)="cancel()"></p-button>
            <p-button label="Confirm" styleClass="confirm-btn" [disabled]="!canConfirm" (onClick)="confirm()"></p-button>
        </div>
    </div>

    <h2 class="page-title">Add New Item Group</h2>

    <!-- Section 1: Search -->
    <h3 class="section-title">Select an Item to Monitor</h3>
    <div class="search-wrapper">
        <div class="search-input">
            <i class="pi pi-search"></i>
            <input type="text" placeholder="Search item..."
                   [(ngModel)]="searchQuery"
                   (input)="onSearch()"
                   [disabled]="!!selectedItem" />
        </div>
        <div class="suggestions" *ngIf="suggestions.length > 0">
            <div tabindex="0" class="suggestion-item" *ngFor="let item of suggestions" (click)="selectItem(item)" (keydown.enter)="selectItem(item)">
                {{ item.medGroupName }}
            </div>
        </div>
    </div>
    <div class="selected-item-display" *ngIf="selectedItem">
        <span class="selected-chip">
            {{ selectedItem.medGroupName }}
            <i tabindex="0" class="pi pi-times" (click)="clearSelection()" (keydown.enter)="clearSelection()"></i>
        </span>
    </div>

    <!-- Section 2: Diversion Weight -->
    <h3 class="section-title">Select Diversion Weight</h3>
    <p class="section-desc">Controls how strongly this item contributes to user risk scoring.</p>
    <app-weight-selector [selectedWeight]="selectedWeight" [disabled]="!selectedItem" (weightChange)="onWeightChange($event)"></app-weight-selector>

    <ng-container *ngIf="assayManagementEnabled">
        <!-- Section 3: Assay -->
        <h3 class="section-title">Waste Assay Testing Preference</h3>
        <div class="assay-section" [class.disabled]="!selectedItem">
            <div class="assay-info">
                <strong>Assay trackable</strong>
                <p>Include this item in the waste assay testing program. Typically used for injectables.</p>
            </div>
            <p-toggleSwitch [(ngModel)]="assayTrackable" [disabled]="!selectedItem"></p-toggleSwitch>
        </div>
    </ng-container>

    <!-- Confirmation Dialog -->
    <p-dialog header="Confirm Item Group and Diversion Weight" [(visible)]="showConfirmDialog" [modal]="true" [closable]="true" [style]="{width: '32rem'}" styleClass="confirm-dialog">
        <p class="dialog-body">
            You adjusted the diversion weight of <strong>{{ selectedItem?.medGroupName }}</strong> to <strong>{{ weightLabel }}</strong>.
            This will impact risk scoring used for compliance monitoring. Are you sure you want to confirm?
        </p>
        <ng-template pTemplate="footer">
            <p-button label="No" [outlined]="true" styleClass="dialog-btn-no" (onClick)="cancelConfirm()"></p-button>
            <p-button label="Yes" styleClass="dialog-btn-yes" (onClick)="confirmSave()"></p-button>
        </ng-template>
    </p-dialog>
</div>

